import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../shared/layout/layout.component';
import { BusinessUserComponent } from './admin/business-user/business-user.component';
import { ClientComponent } from './admin/client/client.component';
import { ImportComponent } from './admin/import/import.component';
import { ExportComponent } from './admin/export/export.component';
import { ProcessedComponent } from './admin/processed/processed.component';
import { GarbageComponent } from './admin/garbage/garbage.component';
import { ClientListComponent } from './admin/client-list/client-list.component';
import { ReportComponent } from './admin/report/report.component';
import { UserReportComponent } from './admin/user-report/user-report.component';
import { BaseDataReportComponent } from './admin/base-data-report/base-data-report.component';
import { EditComponentBusinessuser } from './caseworker/dashboard/edit/edit.component';
import { AddComponentBusinessuser } from './caseworker/dashboard/add/add.component';
import { AddCustomerOverviewComponent } from './caseworker/dashboard/add-customer-overview/add-customer-overview.component';
import { EditComponentBusinessuserAdmin } from './admin/business-user/edit/edit.component';
import { AddComponentBusinessuserAdmin } from './admin/business-user/add/add.component';
import { AddCustomerAdminOverviewComponent } from './admin/business-user/add-customer-overview/add-customer-overview.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'businessuser', pathMatch: 'full' },
      {
        path: 'businessuser',
        component: BusinessUserComponent
      },
      {
        path: 'businessuser/overviewCustomer',
        component: AddCustomerAdminOverviewComponent
      },
      {
        path: 'businessuser/overviewCustomer/add/:type',
        component: AddComponentBusinessuserAdmin
      },      
      {
        path: 'businessuser/edit/:id',
        component: EditComponentBusinessuserAdmin
      },
      {
        path: 'client',
        component: ClientComponent
      },
      {
        path: 'client-list',
        component: ClientListComponent
      },
      {
        path: 'import',
        component: ImportComponent
      },
      {
        path: 'export',
        component: ExportComponent
      },
      {
        path: 'processed',
        component: ProcessedComponent
      },
      {
        path: 'garbage',
        component: GarbageComponent
      },
      {
        path: 'report',
        component: ReportComponent
      },
      {
        path: 'userreport',
        component: UserReportComponent
      },
      {
        path: 'basedatareport',
        component: BaseDataReportComponent
      },     
      {
        path: 'mandant',
        loadChildren: () => import('../inside/admin/mandant/mandant.module').then( m => m.MandantModule)
      },
      {
        path: 'legal',
        loadChildren: () => import('../shared/legal/legal.module').then( m => m.LegalModule)
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
